import React from 'react';
import {RaisedButton, TextField, CardActions, Snackbar} from "material-ui";
import {Link, withRouter} from "react-router-dom";
import {createSubscriber} from "../actions/lead";
import { connect } from 'react-redux';
import {validateEmail} from '../helpers/index'
import { HashLink } from 'react-router-hash-link';
import moment from "moment";
import {trim} from 'lodash'

const penalCharges = `https://drive.google.com/file/d/1ZrTCIO9aa02XzBY85hhmZqA1jMX39RRU/view?usp=sharing`

class FooterNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
        }
    }

     onHandleRequestClose = () => {
        this.setState({
            snackOpen: false,
        });
    }

    onSubmit = async (e) => {
        e.preventDefault();
        const currentPath = trim(`${window.location.pathname}`,'/')
        const page = currentPath ? currentPath : 'home'
        if (await this.validate()) {
            const body = {
                email: this.state.email,
                subscription_for: page
            };
            this.setState({disabled: true});
            const res = await this.props.createSubscriber(body);
            if (res) {
                this.setState({
                    snackOpen: true,
                    email: '',
                });
            } else {
                alert('Something Went Wrong.');
            }
        }
    }

    onHandleRequestClose = () => {
        this.setState({
            snackOpen: false,
        });
    };

    onInputChange = (e, key) => {
        this.setState({
            [key]: e.target.value
        });
    }

    validate = async () => {
        let validateFlag = true;
        if (!validateEmail(this.state.email)) {
            validateFlag = false;
            this.setState({
                emailError: alert(`Not a valid Email`)
            });
        } else {
            this.setState({
                emailError: ''
            });
        }
        return validateFlag;
    }

    downloadLoanCharges = () => {
        window.open(penalCharges, '_blank');
    }

    render(){
        const mainLogoImg = 'images/ascend_logo.png';
        return(
            <div className="footer-section footer-section-dark">
                <div className="container">
                    <div className="footer-newsletter-section footer-newsletter-dark">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-xl-8">
                                <div className="footer-newsletter-content">
                                    <h2>Subscribe to our newsletter</h2>
                                    <p>Be the first to know about exciting loan products, offers and latest industry news</p>
                                </div>
                            </div>
                            <div className="col-lg-7 col-xl-6">
                                <div className="footer-newsletter-form">
                                    <form onSubmit={e => this.onSubmit(e)}>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your email address"
                                                value={this.state.email}
                                                onChange={e => this.onInputChange(e, 'email')}
                                            />
                                            <button
                                                className="btn-action-dark"
                                                style={{
                                                    width: '150px',
                                                    height: '60px',
                                                    marginTop: '0px'
                                                }}
                                                type="submit"
                                            >
                                                Subscribe
                                            </button>
                                            <Snackbar
                                                open={this.state.snackOpen}
                                                message='Thank you for Subscription'
                                                autoHideDuration={4000}
                                                onRequestClose={this.onHandleRequestClose}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row margin-decrese">
                        <div className="col-xl-4 col-lg-5 col-margin">
                            <div className="single-footer">
                                <div className="footer-title">
                                    <Link to={"/"}><div className="row align-items-center brand">
                                        <div className="col-5 footer-logo"><img src={mainLogoImg} alt=""/></div>
                                        <div className="col-7"><span className="brand_name footer">ASCEND CAPITAL</span></div>
                                    </div></Link>
                                </div>
                                <div className="footer-text">
                                    <p>Ascend Capital, 601-610, 4th Floor, Anchor Mall, Civil Lines, Jaipur 302006 <br/>Mobile: +91-8741092723, Email: info@ascendcap.in</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-4 col-6 offset-lg-1 col-margin">
                            <div className="single-footer">
                                <div className="footer-title">
                                    <h6>Company</h6>
                                </div>
                                <ul className="footer-list">
                                    <li><Link to={"/about_us"}>About Us</Link></li>
                                    <li><HashLink to={"/about_us#team"}>Team</HashLink></li>
                                    <li><HashLink to={"/#how_it_works"}>How it Works</HashLink></li>
                                    <li><HashLink to={"/environmental_and_social_policy"}>Environmental and Social Policy</HashLink></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-4 col-6 col-margin">
                            <div className="single-footer">
                                <div className="footer-title">
                                    <h6>Product & Charges</h6>
                                </div>
                                <ul className="footer-list">
                                    {/* <li><HashLink to={"/#lap"}>Loan Against Property</HashLink></li> */}
                                    <li><HashLink to={"/#erickshaw"}>E-rickshaw Loan</HashLink></li>
                                    <li><HashLink to={"/#l5"}>L5 Loan</HashLink></li>
                                    <li><a onClick={this.downloadLoanCharges} style={{color: '#528FF0', cursor: 'pointer'}}>Penal & Other Charges</a></li>
                                    <li><a href="https://docs.google.com/forms/d/17NHlGfLLZStnu1gzQP71UI8e2w7u4bLN0StR7bzdQkc/edit" target="_self">NACH Cancellation Request</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-4 col-margin">
                            <div className="single-footer">
                                <div className="footer-title">
                                    <h6>Help</h6>
                                </div>
                                <ul className="footer-list">
                                    <li><Link to={"/contact"}>Contact Us</Link></li>
                                    <li><Link to={"/privacy"}>Privacy Policy</Link></li>
                                    {/* <li><Link to={"/career"}>Career</Link></li> */}
                                    <li><Link to={"/customer_grievance"}>Grievance & Redressal</Link></li>
                                    <li><Link to={"/fair_practice_code"}>Fair Practice Code</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="footer-title">
                        <h6>@<b>{moment().format('YYYY')}</b> Ascend Bizcap Pvt. Ltd. All rights reserved.</h6>
                    </div>

                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    createSubscriber: body => dispatch(createSubscriber(body)),
});

export default withRouter(connect(null, mapDispatchToProps)(FooterNew))



// WEBPACK FOOTER //
// ./src/components/FooterNew.js